import { useUserInfo } from '@/provider/UserInfoProvider';
import Defer from '@/utils/defer';
import { useCallback, useEffect } from 'react';

interface UseLoginAuthProps {
  from: string;
}

export const loginAuthDefer = Defer<string>(); // 用户在获取auth期间上传会进行等待auth获取成功后再上传（可跨页面/组件使用，用户无感知）
let loginOnceLock = false; // 获取auth的登录锁

/**
 * @description 引入useLoginAuth这个hook如果用户未登录会立即匿名登录，
 * 但是多次引入由于存在loginOnceLock，所以只会登录一次
 */
const useLoginAuth = ({ from: _from }: UseLoginAuthProps) => {
  const {
    userIdentity,
    getAuthToken,
    isLoadingUser: isUserInfoLoading,
    signInAnonymous,
  } = useUserInfo();
  const isNotUser = userIdentity === 1;

  const getUserLoginAuth = useCallback(async () => {
    loginOnceLock = true;
    // 非用户先匿名登录
    if (isNotUser) {
      await signInAnonymous(_from);
      const newAuthToken = await getAuthToken();

      newAuthToken
        ? loginAuthDefer.resolve(newAuthToken)
        : loginAuthDefer.reject(`get newAuthToken fail`);
    } else {
      const curAuthToken = await getAuthToken();

      curAuthToken
        ? loginAuthDefer.resolve(curAuthToken)
        : loginAuthDefer.reject(`get authToken fail`);
    }
  }, [_from, getAuthToken, isNotUser, signInAnonymous]);

  useEffect(() => {
    // 加载完用户登录/未登录状态后，并且没有执行过获取登录auth
    if (!isUserInfoLoading && !loginOnceLock) {
      getUserLoginAuth();
    }
  }, [getUserLoginAuth, isUserInfoLoading]);
};

export default useLoginAuth;
